<script setup lang="ts">
    import { Button } from '../../Button';
    import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../components';
    import { useDialogs } from '../dialogs.store';

    const props = defineProps<{
        title?: string;
        description?: string;
        message?: string;

        cancelLabel?: string;
        confirmLabel?: string;
        onConfirm?: () => Promise<any>;
    }>();

    const dialogsStore = useDialogs();
    const { t } = useI18n();
    const isLoading = ref(false);

    async function handleConfirm() {
        if (props.onConfirm) {
            isLoading.value = true;
            await props.onConfirm().finally(() => (isLoading.value = false));
        }

        dialogsStore.close(true);
    }
</script>

<template>
    <Dialog default-open>
        <DialogContent>
            <DialogHeader>
                <DialogTitle>{{ title ?? t('GLOBAL.CONFIRM') }}</DialogTitle>
                <DialogDescription class="sr-only">{{ description ?? t('CONFIRM_YOUR_ACTION') }}</DialogDescription>
            </DialogHeader>

            <div>
                {{ message ?? t('ARE_YOU_SURE') }}
            </div>

            <DialogFooter>
                <DialogClose as-child>
                    <Button variant="tertiary">{{ cancelLabel ?? t('GLOBAL.CANCEL') }}</Button>
                </DialogClose>

                <Button
                    variant="brand"
                    :disabled="isLoading"
                    :loading="isLoading"
                    @click="handleConfirm"
                >
                    {{ confirmLabel ?? t('GLOBAL.CONFIRM') }}
                </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<i18n lang="yaml">
en:
    ARE_YOU_SURE: Are you sure?
    CONFIRM_YOUR_ACTION: Confirm your action.
nl:
    ARE_YOU_SURE: Weet je het zeker?
    CONFIRM_YOUR_ACTION: Bevestig je actie.
</i18n>
